import React, { ReactNode } from 'react'
import { Cancel, NotificationsNoneOutlined } from '@mui/icons-material'
import { Badge, Card, CardContent, Drawer, IconButton, List, ListItemButton, Stack, Tooltip, Typography } from '@mui/joy'
import { Link } from 'react-router-dom'
import useNotificationPanel from './utils/useNotificationPanel'
import { useSelector, useDispatch } from 'react-redux'
import { selectExamStore } from 'store/ExamStore/slice/selector'
import { TypeExam } from 'app/constants/types/exam.types'
import { fetchExams, useExamStoreSlice } from 'store/ExamStore/slice/index'


type Props = {
  slot?: { button?: ReactNode }
}
const NotificationPanel = ({ slot }: Props) => {
  useExamStoreSlice() // Inject the reducer
  const dispatch = useDispatch()
  const {
    open,
    setOpen,
    unread,
    data,
  } = useNotificationPanel({})

  const examStore = useSelector(selectExamStore)
  console.log('Exam Store:', examStore)

  React.useEffect(() => {
    // Fetch exams when component mounts and when notifications panel is opened
    console.log('Fetching exams...')
    dispatch(fetchExams())
  }, [dispatch, open])

  // Log when notifications data changes
  React.useEffect(() => {
    console.log('Notifications data:', data)
  }, [data])

  return (
    <Stack>
      <Tooltip title='Open Notifications' >
        <Badge badgeContent={unread} size='sm' sx={{ '& .MuiBadge-badge': { top: "5px", right: "5px" } }}>
          <IconButton onClick={() => setOpen(!open)} sx={{ }}>
            <NotificationsNoneOutlined />
            {slot?.button}
          </IconButton>
        </Badge>
      </Tooltip>
      <Drawer
        open={open}
        anchor='right'
        onClose={() => setOpen(!open)}
        sx={{
          '& .MuiDrawer-content': {
            backgroundColor: 'unset',
            boxShadow: 'unset',
          }
        }}
      >
        <Card sx={{
          overflow: 'auto',
          background: "#F4F7FF",
          boxShadow: "0px 4px 4px #BACAF2",
          borderRadius: "12px",
          height: 1,
          m: 2,
        }}>
          <CardContent>
            <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', gap: 1, alignItems: 'center' }}>
              <Typography level='h3'>Notifications</Typography>
              <IconButton onClick={() => setOpen(!open)}>
                <Cancel />
              </IconButton>
            </Stack>
            <List sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {
                data?.map((item, index) => {

                  return (
                    <ListItemButton
                      key={index}
                      component={Link}
                      to={`/student/${item.examId}`}
                      onClick={() => setOpen(!open)}
                      sx={{ gap: 2, py: 2, px: 2, pb: 4, borderRadius: 8, boxShadow: "0px 4px 4px #BACAF2", backgroundColor: 'white', '&:hover': { backgroundColor: 'white !important' }, position: 'relative' }}>
                      <Stack spacing={0.5} sx={{ width: '100%' }}>
                        {(() => {
                          const exam = examStore.exams?.find((e: TypeExam) => e.examId === item.examId)
                          return (
                            <>
                              <Typography level='title-lg'>
                                {exam?.title || item?.title}
                              </Typography>
                              {exam?.level && (
                                <Typography level='body-sm'>
                                  Level: {exam.level}
                                </Typography>
                              )}
                              {exam?.description && (
                                <Typography level='body-sm'>
                                  Paper: {exam.description}
                                </Typography>
                              )}
                              <Typography level='body-md'>
                                {item?.message}
                              </Typography>
                              <Typography
                                level='body-sm'
                                color='neutral'
                                sx={{
                                  position: 'absolute',
                                  bottom: 8,
                                  right: 16,
                                }}
                              >
                                {new Date(item.timestamp).toLocaleString()}
                              </Typography>
                            </>
                          )
                        })()}
                      </Stack>
                    </ListItemButton>
                  )

                })
              }
            </List>
          </CardContent>
        </Card>
      </Drawer>
    </Stack>
  )
}

export default NotificationPanel
